module.exports = __webpack_public_path__ + "img/nba21.d02ed17e.png";